import React__default, { useState, useCallback, useEffect } from 'react';
import classnames from 'classnames';
import { Alert, Button } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { Util, Form, DateOfBirthSelect } from '@grandvisionhq/forms';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl, useSelector, useDispatch } from '@grandvisionhq/state';
import { goto } from '../../actions.js';
import { getAuth } from '../../selectors.js';
import { isUninitialized } from '../../state.js';
import { useValidateAccount } from '../hooks/use-validate-account.js';

const formatDate = (date)=>{
    const [year, month, day] = date.split('-');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
var Verify = (()=>{
    const elementName = 'verify';
    const { href: createRoute  } = useLink({
        route: 'auth.create'
    }) || {};
    const { getLabel  } = useIntl();
    const auth = useSelector(getAuth);
    const dispatch = useDispatch();
    const [formState1, setFormState] = useState(Util.fieldsToFormState({
        dob: ''
    }));
    const [validateAccount, { error , loading , customerId , retries , isWrongDOB  }] = useValidateAccount();
    const handleSubmit = useCallback((formState)=>{
        const { dob  } = Util.getValuesFromState(formState.formState);
        if (dob) {
            try {
                validateAccount({
                    customerId: auth.userId,
                    validationValue: formatDate(dob)
                });
            } catch (e) {
                console.warn(e);
                console.warn(error);
            }
        }
    }, [
        validateAccount,
        formState1.formState
    ]);
    const handleChange = (newState)=>setFormState(newState.formState)
    ;
    useEffect(()=>{
        if (customerId) dispatch(goto({
            route: createRoute || ''
        }));
    }, [
        createRoute,
        customerId,
        dispatch
    ]);
    if (isUninitialized(auth)) {
        throw new Error('Should not render SignUp page when auth is not initialized');
    }
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames(elementName, 'myaccount__section')
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "medium",
        className: classnames(`${elementName}__title`)
    }, getLabel('account.resetPassword.validation.title')), /*#__PURE__*/ React__default.createElement(Text, {
        className: `${elementName}__text`
    }, getLabel('account.resetPassword.validation.text')), isWrongDOB && /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        icon: "alert-circle",
        message: getLabel('account.resetPassword.validation.error.wrongDateOfBirth')
    }), retries && /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        icon: "alert-circle",
        message: getLabel('account.resetPassword.validation.error.tooManyAttempts')
    }), /*#__PURE__*/ React__default.createElement(Form, {
        name: "verify-form",
        "data-t": "verify-form",
        className: classnames('password-form'),
        initialFormState: formState1,
        onChange: handleChange,
        onSubmit: handleSubmit
    }, /*#__PURE__*/ React__default.createElement(DateOfBirthSelect, {
        name: "dob",
        label: getLabel('account.resetPassword.validation.dateOfBirth'),
        dayPlaceholder: getLabel('checkout.contact.dateofbirth.day.placeholder'),
        monthPlaceholder: getLabel('checkout.contact.dateofbirth.month.placeholder'),
        yearPlaceholder: getLabel('checkout.contact.dateofbirth.year.placeholder'),
        errorMessage: getLabel('account.resetPassword.validation.error.noDateOfBirth'),
        validations: [
            Util.validations.isDateOfBirth,
            Util.validations.isRequired
        ],
        required: true
    }), /*#__PURE__*/ React__default.createElement(Button, {
        caption: getLabel('account.action.confirm'),
        "data-t": "submit",
        type: "submit",
        className: "password-form__button",
        disabled: retries !== undefined,
        isLoading: loading
    })));
});

export { Verify as default };
//# sourceMappingURL=Verify.js.map
